// extracted by mini-css-extract-plugin
export default {"cls1":"Z99Hmii4s59xV3QYEYuQ","cls2":"pu67XKIVnOhVx7D1iBKC Z99Hmii4s59xV3QYEYuQ","centerDetails":"RO_Z6VEOho4nXdbia4UB"};